import { useMemo } from "react";

export function YearSelector({ selectedYear, onYearChange, availableYears, accentColor = "var(--oh-stat-blue-text)" }) {
  // T-432 PN-23 : un jeton (`var(--…)`) n'est pas un hexadécimal : on le teinte par color-mix au lieu d'en tirer un « rgba(NaN…) » invalide.
  const estJeton = accentColor.startsWith("var(");
  const bgActive = useMemo(() => {
    if (estJeton) return `color-mix(in srgb, ${accentColor} 20%, transparent)`;
    const hex = accentColor.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r},${g},${b},0.2)`;
  }, [accentColor]);

  const borderActive = useMemo(() => {
    if (estJeton) return `color-mix(in srgb, ${accentColor} 50%, transparent)`;
    const hex = accentColor.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r},${g},${b},0.5)`;
  }, [accentColor]);

  if (!availableYears?.length) return null;

  return (
    <div className="ml-auto flex gap-1">
      {availableYears.map(y => (
        <button
          key={y}
          onClick={() => onYearChange(y)}
          className="px-2.5 py-1 rounded-md text-xs font-medium transition-all"
          data-testid={`year-${y}`}
          style={{
            background: selectedYear === y ? bgActive : "var(--oh-bg-surface)",
            border: `1px solid ${selectedYear === y ? borderActive : "var(--oh-border)"}`,
            color: selectedYear === y ? accentColor : "var(--oh-text-muted)",
          }}
        >
          {y}
        </button>
      ))}
    </div>
  );
}

export function useYearFilter(data, fieldPath = "evolution_mensuelle") {
  return useMemo(() => {
    const evo = data?.[fieldPath];
    if (!evo) return [];
    const years = [...new Set(evo.map(m => m.mois.slice(0, 4)))];
    return years.sort();
  }, [data, fieldPath]);
}
